<template>
    <div>
        <div class="about" :class="{ active: animate }">
      <div class="aboutHeader">
        <img
          src="../../../../assets/telecom/telecom.jpg"
          alt="aboutHeader"
          id="aboutHeaderImage"
        />
      </div>
      <div class="top-left">
        <h1 class="drop-from-top">
           CCS in Telecom 
        </h1>
        <p class="drop-from-bottom">
            Connecting Tomorrow, Today: Your Telecom Partner
        </p>
      </div>
    </div>
    </div>
</template>

<script src="./first.js"></script>
<style src="./first.css"></style>